import {computed, ref, shallowRef} from "@vue/reactivity";

const twitch_role = ref('');
const theme_mode = ref('light');
let autoPlayBattles = ref(false);
let twitch_id = ref("");

function setColorScheme(scheme) {
    switch (scheme) {
        case 'dark':
            // Dark
            theme_mode.value = 'dark';
            break;
        case 'light':
            // Light
            theme_mode.value = 'light';
            break;
        default:
            // Default
            theme_mode.value = 'dark';
            break;
    }
}


function getPreferredColorScheme() {
    if (window.matchMedia) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        } else {
            return 'light';
        }
    }
    return 'dark';
}

if (window.matchMedia) {
    var colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    colorSchemeQuery.addEventListener('change', setColorScheme(getPreferredColorScheme()));
}

const pcgThemeStyle = computed(() => {
    if (theme_mode.value === 'light') {
        return {
            backgroundColor: 'white',
            color: '#282828'
        };
    } else {
        return {
            backgroundColor: '#363636',
            color: 'white'
        };
    }
});

const pcgSecondaryThemeStyle = computed(() => {
    if (theme_mode.value === 'light') {
        return {
            backgroundColor: 'white',
            color: 'black'
        };
    } else {
        return {
            color: 'white',
            backgroundColor: '#e14545'

        };
    }
});

const currentView = shallowRef();
const battleContent = shallowRef({
    "isViewer": false,
    "id": -1,
    "liveView": false,
    "speed": 5
});

export {
    currentView,
    battleContent,
    pcgThemeStyle,
    pcgSecondaryThemeStyle,
    theme_mode,
    autoPlayBattles,
    twitch_id,
    twitch_role
}